var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M.5 3.5h7.814a6.5 6.5 0 0 1 5.878 3.724L15.2 9.36a1.5 1.5 0 0 1-1.356 2.141H.5z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#1C1C1A",
  d: "M12.412 5H6v3h8.5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M14 14a.5.5 0 0 0 0-1zM0 13h-.5v1H0zm14 0H0v1h14z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export { SvgTrain as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzNfMzQ4KSI+CjxwYXRoIGQ9Ik0wLjUgMy41SDguMzE0MzJDMTAuODI5IDMuNSAxMy4xMTgxIDQuOTUwNTMgMTQuMTkxOSA3LjIyNDQ2TDE1LjIwMDEgOS4zNTk0OUMxNS42NyAxMC4zNTQ1IDE0Ljk0NDIgMTEuNSAxMy44NDM4IDExLjVIMC41VjMuNVoiIHN0cm9rZT0iYmxhY2siLz4KPHBhdGggZD0iTTEyLjQxMTggNUg2VjhIMTQuNSIgc3Ryb2tlPSIjMUMxQzFBIi8+CjxwYXRoIGQ9Ik0xNCAxNEMxNC4yNzYxIDE0IDE0LjUgMTMuNzc2MSAxNC41IDEzLjVDMTQuNSAxMy4yMjM5IDE0LjI3NjEgMTMgMTQgMTNWMTRaTTAgMTNILTAuNVYxNEgwVjEzWk0xNCAxM0wwIDEzVjE0TDE0IDE0VjEzWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zXzM0OCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";